import { AuthModel } from '../auth/model';
import { computed, observable } from 'mobx';
import { EnvModel } from '../env/model';
import {AccountsAPI} from '../../types/api';
import {User} from '../../types/user';
import {ChannelSchema} from '../../types/schema';

export class UserModel {
  constructor(
    private auth: AuthModel,
    private env: EnvModel,
  ) {}

  @observable loadingAccounts = false;

  @observable accounts: AccountsAPI = {
    dropbox: [],
    twitter: [],
    facebook: [],
    spotify: [],
    youtube: []
  };

  @observable isUnlinking = {
    spotify: false,
    twitter: false,
    dropbox: false,
    facebook: false,
  };

  @observable
  loading: boolean = true;

  @observable
  loadingChannels: boolean = true;

  @computed
  get user(): User {
    return this.auth.user;
  }

  @observable channel: ChannelSchema = null;
  @observable channelBrandSponsored: ChannelSchema = null;

  @observable channels: Array<ChannelSchema> = [];
  
  @computed get spotify() {
    const isLinked = this.accounts && this.accounts.spotify && this.accounts.spotify.length > 0;

    return {
      isLinked,
      name: isLinked ? this.accounts.spotify[0].name : null,
      linkURL: this.auth.spotifyLoginURL,
      isUnlinking: this.isUnlinking.spotify
    }
  }

  @computed get twitter() {
    const isLinked = this.accounts && this.accounts.twitter && this.accounts.twitter.length > 0;

    return {
      isLinked,
      name: isLinked ? this.accounts.twitter[0].name : null,
      linkURL: this.auth.twitterLoginURL,
      isUnlinking: this.isUnlinking.twitter
    }
  }

  @computed get dropbox() {
    const isLinked = this.accounts && this.accounts.dropbox && this.accounts.dropbox.length > 0;

    return {
      isLinked,
      name: isLinked ? this.accounts.dropbox[0].name : null,
      linkURL: this.auth.dropboxLoginURL,
      isUnlinking: this.isUnlinking.dropbox
    }
  }

  @computed get facebook() {
    const isLinked = this.accounts && this.accounts.facebook && this.accounts.facebook.length > 0;

    return {
      isLinked,
      name: isLinked ? this.accounts.facebook[0].name : null,
      linkURL: this.auth.facebookLoginURL,
      isUnlinking: this.isUnlinking.facebook
    }
  }

  @computed get referralURL() {
    if (!this.channel) return '';

    return `${this.env.baseUrl}/r/${this.channel.referrer_url || this.channel.id}`;
  }

  @computed get referralTitle() {
    if (!this.channel) return '';

    return `${this.channel.name} would like to invite you to get your 1st track free on Lickd!`;
  }
}